import notificationService from "@/services/notification";
export default {
    state: {
        notificationDefault: {
            title: "",
            content: "",
            active: false
        },
        notification: {}
    },
    mutations: {
        setNotification(state, payload) {
            state.notification = { ...state.notificationDefault, ...payload };
        }
    },
    actions: {
        async setNotification({ commit }, payload) {
            commit("setNotification", payload);
        },
        resetNotification({ commit }) {
            commit("setNotification", {});
        },
        async removeNotification(context, payload) {
            const { id } = payload;
            await notificationService.remove(id);
        }
    }
};
